import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        {/* Diver SVG illustration */}
        <motion.div
          className="not-found-illustration"
          animate={{ y: [0, -12, 0] }}
          transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
        >
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="diver-svg" aria-hidden="true">
            {/* Bubbles */}
            <circle cx="130" cy="60" r="6" fill="rgba(26,86,219,0.2)" />
            <circle cx="142" cy="42" r="4" fill="rgba(26,86,219,0.15)" />
            <circle cx="135" cy="25" r="3" fill="rgba(26,86,219,0.1)" />
            {/* Tank */}
            <rect x="100" y="95" width="18" height="32" rx="9" fill="#1a56db" />
            {/* Body */}
            <ellipse cx="88" cy="108" rx="22" ry="16" fill="#1e3a8a" />
            {/* Head */}
            <circle cx="88" cy="85" r="16" fill="#f59e0b" />
            {/* Mask */}
            <rect x="78" y="80" width="20" height="13" rx="5" fill="#1a56db" opacity="0.8" />
            <rect x="80" y="82" width="16" height="9" rx="3" fill="rgba(200,230,255,0.6)" />
            {/* Fins */}
            <ellipse cx="68" cy="120" rx="18" ry="6" fill="#1a56db" transform="rotate(-20 68 120)" />
            <ellipse cx="108" cy="120" rx="18" ry="6" fill="#1a56db" transform="rotate(20 108 120)" />
            {/* Arms */}
            <line x1="70" y1="105" x2="55" y2="118" stroke="#1e3a8a" strokeWidth="6" strokeLinecap="round" />
            <line x1="106" y1="105" x2="121" y2="118" stroke="#1e3a8a" strokeWidth="6" strokeLinecap="round" />
            {/* Question mark speech bubble */}
            <ellipse cx="155" cy="70" rx="28" ry="22" fill="white" stroke="#1a56db" strokeWidth="2" />
            <path d="M143 70 L135 82" stroke="white" strokeWidth="2" fill="white" />
            <text x="148" y="77" fontSize="22" fontWeight="bold" fill="#1a56db" fontFamily="serif">?</text>
          </svg>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <p className="not-found-code">404</p>
          <h1 className="not-found-title">Looks like this page dove too deep and got lost!</h1>
          <p className="not-found-message">
            The page you're looking for doesn't exist, or may have drifted away with the current.
          </p>

          <div className="not-found-actions">
            <Link to="/" className="btn not-found-btn-primary">
              🏠 Go Home
            </Link>
            <Link to="/blog" className="btn not-found-btn-secondary">
              📖 Browse Blog Posts
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFoundPage;
